<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div v-if="loading" class="loader">Loading...</div>
          <div slot="header">
            <b-row>
              <b-col><strong>Approver Configuration</strong></b-col>
              <b-col class="text-right">
                 <b-button variant="primary" @click="systemUserConfig" class="btn-add">
                    List Approver Users
                  </b-button>
                <b-button variant="success" @click="openNewConfig" class="btn-add">
                  Add Approver Configuration
                </b-button>
              </b-col>
              
            </b-row>
          </div>
          <div>
             <div class="mb-3">
              <b-form-input 
                v-model="searchQuery" 
                placeholder="Search Approval Process" 
                @input="filterConfigurations"
              ></b-form-input>
            </div>
            <div class="table-responsive">
              <table class="table mt-3">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Approval Process</th>
                    <th style="word-break: break-all;width:10%;">Condition</th>
                    <th>No Of Level</th>
                    <th>Level 1 Approver</th>
                    <th>Level 2 Approver</th>
                    <th>Level 3 Approver</th>
                     <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in filteredConfigurations" :key="item.approvalconfigid">
                    <td>{{ index + 1 }}</td>
                    <td style="word-break: break-all;width:20%;"> {{ formatModuleUrl(item.moduleurl) }}</td>
                    <td style="word-break: break-all;width:10%;">{{ capitalizeFirstLetter(item.approvalcondition) }}
                     <p>{{ item.bspl_percentage ? 'BSPL-'+item.bspl_percentage+'%': '' }}</p>
                     <p>{{ item.darp_percentage ? 'Darp-'+item.darp_percentage+'%': '' }} </p>

                    </td>
                    
                    <td>{{ item.no_of_level }}</td>
                  <!-- Level 1 Approver -->
                    <td>
                      <span :id="'level1-' + item.approvalconfigid" :class="{ underline: item.levels.level1 }">
                        {{ item.levels.level1 ? 'Yes' : 'No' }}
                      </span>
                      <b-tooltip 
                        v-if="item.levels.level1" 
                        :target="'level1-' + item.approvalconfigid" 
                        html 
                        placement="top" 
                        :delay="{ show: 300, hide: 100 }">
                        <template #default>
                          <div class="tooltip-content"> <!-- Add a class here -->
                            <ul v-if="item.mandatoryUsers.level1.length > 0" class="inline-list">
                              <li v-for="(user, i) in item.mandatoryUsers.level1" :key="user.sysusermasterid">
                                {{ i + 1 }}. {{ user.sysemailid }}
                              </li>
                            </ul>
                            <span v-else>No mandatory users</span>
                          </div>
                        </template>
                      </b-tooltip>
                    </td>

                    <!-- Level 2 Approver -->
                    <td>
                      <span :id="'level2-' + item.approvalconfigid" :class="{ underline: item.levels.level2 }">
                        {{ item.levels.level2 ? 'Yes' : 'No' }}
                      </span>
                      <b-tooltip 
                        v-if="item.levels.level2" 
                        :target="'level2-' + item.approvalconfigid" 
                        html 
                        placement="top" 
                        :delay="{ show: 300, hide: 100 }">
                        <template #default>
                          <div class="tooltip-content">
                            <ul v-if="item.mandatoryUsers.level2.length > 0" class="inline-list">
                              <li v-for="(user, i) in item.mandatoryUsers.level2" :key="user.sysusermasterid">
                                {{ i + 1 }}. {{ user.sysemailid }}
                              </li>
                            </ul>
                            <span v-else>No mandatory users</span>
                          </div>
                        </template>
                      </b-tooltip>
                    </td>

                    <!-- Level 3 Approver -->
                    <td>
                      <span :id="'level3-' + item.approvalconfigid" :class="{ underline: item.levels.level3 }">
                        {{ item.levels.level3 ? 'Yes' : 'No' }}
                      </span>
                      <b-tooltip 
                        v-if="item.levels.level3" 
                        :target="'level3-' + item.approvalconfigid" 
                        html 
                        placement="top" 
                        :delay="{ show: 300, hide: 100 }">
                        <template #default>
                          <div class="tooltip-content">
                            <ul v-if="item.mandatoryUsers.level3.length > 0" class="inline-list">
                              <li v-for="(user, i) in item.mandatoryUsers.level3" :key="user.sysusermasterid">
                                {{ i + 1 }}. {{ user.sysemailid }}
                              </li>
                            </ul>
                            <span v-else>No mandatory users</span>
                          </div>
                        </template>
                      </b-tooltip>
                    </td>
                    <td>
                     {{ item.status === 1 ? 'Active' : 'inactive' }}
                    </td>


                    <td>
                      <b-button size="sm" variant="primary" @click="editProcess(item)">Edit / View</b-button>
                    </td>
                  </tr>
                  <tr v-if="!existingConfigurations.length">
                    <td colspan="9" class="text-center">No records found</td>
                  </tr>
                </tbody>
              </table> 
            </div>          
            <b-modal ref="viewPlanDetails-modal" size="xl" hide-footer @hide="resetConfig">
              <template #modal-title>
                <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                  <h4>{{ isEditing ? 'Edit Approver Configuration' : 'Add New Approver Configuration' }}</h4>
                  <small v-if="lastmodifiedby && isEditing">
                  Last Updated {{ lastmodifiedby }} On {{ lastmodifieddate }}
                  
                  </small>
                </div>
              </template>
              <div class="approver-form">
                <b-row>
                  <b-col md="6">
                    <div class="form-group">
                      <label> Approval Process</label>
                     <b-form-select v-model="selectedProcess" @input="clearError('process')">
                      <option :value="null" disabled>Select Approval Process</option>
                      <option v-for="process in processes" :key="process.moduleurl" :value="process.moduleurl">
                        {{ formatModuleUrl(process.moduleurl) }}
                      </option>
                    </b-form-select>
                      <small v-if="errors.process" class="text-danger">{{ errors.process }}</small>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div class="form-group">
                      <label> Conditions</label>
                       <div v-if="selectedProcess === 'trip_level_invoice_generator'">
                        <b-form-radio-group v-model="selectedCondition" @change="clearError('condition')" name="condition-options"  class="radio-group-custom">
                          <b-form-radio v-for="condition in conditions" :key="condition.name" :value="condition.name" class="radio-custom">
                            {{ capitalizeFirstLetter(condition.name) }}
                          </b-form-radio>
                        </b-form-radio-group>
                        <div v-if="selectedCondition &&  selectedCondition=='percentage'">
                        <b-row style="margin-top:10px;">
                           <b-col md="6">
                              <b-form-group label="BSPL (%)" :invalid="bsplInvalid">
                                <b-form-input
                                  v-model="bsplPercentage"
                                  type="number"
                                  min="0"
                                  max="100"
                                  placeholder="Enter BSPL (%)"
                                  required
                                  @input="validatePercentages"
                                ></b-form-input>
                                <b-form-invalid-feedback v-if="bsplInvalid">
                                  BSPL (%) is required and must not exceed 100.
                                </b-form-invalid-feedback>
                              </b-form-group>
                                <small v-if="errors.bsplPercentage" class="text-danger">{{ errors.bsplPercentage }}</small>
                            </b-col>

                            <b-col md="6">
                              <b-form-group label="DARP (%)" :invalid="darpInvalid">
                                <b-form-input
                                  v-model="darpPercentage"
                                  type="number"
                                  min="0"
                                  max="100"
                                  placeholder="Enter DARP (%)"
                                  required
                                  @input="validatePercentages"
                                ></b-form-input>
                              </b-form-group>
                               <small v-if="errors.darpPercentage" class="text-danger">{{ errors.darpPercentage }}</small>
                            </b-col>
                           
                             
                        </b-row>
                        </div>
                      </div>
                      <div v-else>
                        <b-form-select v-model="selectedCondition" @input="clearError('condition')">
                          <option :value="null" disabled>Select Condition</option>
                          <option v-for="condition in conditions" :key="condition.name" :value="condition.name">
                            {{ condition.name }}
                          </option>
                        </b-form-select>
                      </div>  
                      <small v-if="errors.condition" class="text-danger">{{ errors.condition }}</small>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <!-- Level 1 Approvers -->
                  <b-col md="4">
                    <b-form-checkbox v-model="levels.level1" @change="handleLevel1Change">
                      Level 1 Approver
                    </b-form-checkbox>
                    <div v-if="levels.level1">
                      <h5>
                        Mandatory Users for Level 1:
                        <span class="badge badge-info">{{ mandatoryUsers.level1.length }} selected</span>
                      </h5>

                      <!-- Search Input for Level 1 -->
                      <b-form-input
                        v-model="searchQueryLevel1"
                        placeholder="Search users for Level 1"
                      ></b-form-input>

                      <!-- Scrollable User List for Level 1 -->
                      <div class="user-list-scroll">
                        <!-- Selected Users -->
                        <h6>Selected Users</h6>
                        <b-form-group v-for="user in selectedUsers('level1')" :key="user.sysusermasterid">
                          <b-form-checkbox
                            v-model="mandatoryUsers.level1"
                            :value="user"
                            @change="updateMandatoryUsers('level1', user)"
                            custom
                          >
                            {{ user.sysemailid }}
                          </b-form-checkbox>
                        </b-form-group>

                        <!-- Non-selected Users -->
                        <h6>Available Users</h6>
                        <b-form-group v-for="user in nonSelectedUsers('level1')" :key="user.sysusermasterid">
                          <b-form-checkbox
                            v-model="mandatoryUsers.level1"
                            :value="user"
                            @change="updateMandatoryUsers('level1', user)"
                            custom
                          >
                            {{ user.sysemailid }}
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <small v-if="errors.level1Users" class="text-danger">{{ errors.level1Users }}</small>
                    </div>
                  </b-col>

                  <!-- Level 2 Approvers -->
                  <b-col md="4">
                    <b-form-checkbox v-model="levels.level2" @change="handleLevel2Change" :disabled="!isLevel2Enabled">
                      Level 2 Approver
                    </b-form-checkbox>
                    <div v-if="levels.level2">
                      <h5>
                        Mandatory Users for Level 2:
                        <span class="badge badge-info">{{ mandatoryUsers.level2.length }} selected</span>
                      </h5>

                      <!-- Search Input for Level 2 -->
                      <b-form-input
                        v-model="searchQueryLevel2"
                        placeholder="Search users for Level 2"
                      ></b-form-input>

                      <!-- Scrollable User List for Level 2 -->
                      <div class="user-list-scroll">
                        <!-- Selected Users -->
                        <h6>Selected Users</h6>
                        <b-form-group v-for="user in selectedUsers('level2')" :key="user.sysusermasterid">
                          <b-form-checkbox
                            v-model="mandatoryUsers.level2"
                            :value="user"
                            @change="updateMandatoryUsers('level2', user)"
                            custom
                          >
                            {{ user.sysemailid }}
                          </b-form-checkbox>
                        </b-form-group>

                        <!-- Non-selected Users -->
                        <h6>Available Users</h6>
                        <b-form-group v-for="user in nonSelectedUsers('level2')" :key="user.sysusermasterid">
                          <b-form-checkbox
                            v-model="mandatoryUsers.level2"
                            :value="user"
                            @change="updateMandatoryUsers('level2', user)"
                            custom
                          >
                            {{ user.sysemailid }}
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <small v-if="errors.level2Users" class="text-danger">{{ errors.level2Users }}</small>
                    </div>
                  </b-col>

                  <!-- Level 3 Approvers -->
                  <b-col md="4">
                    <b-form-checkbox v-model="levels.level3" @change="handleLevel3Change" :disabled="!isLevel3Enabled">
                      Level 3 Approver
                    </b-form-checkbox>
                    <div v-if="levels.level3">
                      <h5>
                        Mandatory Users for Level 3:
                        <span class="badge badge-info">{{ mandatoryUsers.level3.length }} selected</span>
                      </h5>

                      <!-- Search Input for Level 3 -->
                      <b-form-input
                        v-model="searchQueryLevel3"
                        placeholder="Search users for Level 3"
                      ></b-form-input>

                      <!-- Scrollable User List for Level 3 -->
                      <div class="user-list-scroll">
                        <!-- Selected Users -->
                        <h6>Selected Users</h6>
                        <b-form-group v-for="user in selectedUsers('level3')" :key="user.sysusermasterid">
                          <b-form-checkbox
                            v-model="mandatoryUsers.level3"
                            :value="user"
                            @change="updateMandatoryUsers('level3', user)"
                            custom
                          >
                            {{ user.sysemailid }}
                          </b-form-checkbox>
                        </b-form-group>

                        <!-- Non-selected Users -->
                        <h6>Available Users</h6>
                        <b-form-group v-for="user in nonSelectedUsers('level3')" :key="user.sysusermasterid">
                          <b-form-checkbox
                            v-model="mandatoryUsers.level3"
                            :value="user"
                            @change="updateMandatoryUsers('level3', user)"
                            custom
                          >
                            {{ user.sysemailid }}
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <small v-if="errors.level3Users" class="text-danger">{{ errors.level3Users }}</small>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="footer-buttons">
                  <small v-if="errors.duplicateUsers" class="text-danger">{{ errors.duplicateUsers }}</small>

                  <b-col class="text-right">

                    <b-button @click="validateForm" variant="primary">{{ isEditing ? 'Update' : 'Save' }}</b-button>
                    <b-button @click="resetConfig" variant="secondary">Clear</b-button>

                  </b-col>
                </b-row>
              </div>
            </b-modal>
            <b-modal ref="approverConfigModal" size="xl" hide-footer>
              <template #modal-title>
                <h4>System User Approval Actions</h4>
              </template>

              <div v-if="approveuserslist.length">
                <div class="table-responsive">
                  <table class="table1 table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th  style="word-break: break-all;width:20%;">SysUserMaster ID</th>
                        <th>Email ID</th>
                        <th v-for="process in processes" :key="process.moduleurl">
                        {{ formatModuleUrl(process.moduleurl) }}
                      </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(user, index) in approveuserslist" :key="user.sysusermasterid">
                        <td>{{ index + 1 }}</td>
                        <td>{{ user.sysusermasterid }}</td>
                        <td style="word-break: break-all;width:20%;">{{ user.sysemailid }}</td>
                       <td v-for="process in processes" :key="process.moduleurl">
                        {{ getApprovalLevel(user, process.moduleurl) }}
                      </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- No data message -->
              <div v-else>
                <p>No users found.</p>
              </div>

              <!-- Close Button -->
              <div class="text-right mt-3">
                <b-button variant="secondary" @click="closeConfigModal">Close</b-button>
              </div>
            </b-modal>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Swal from 'sweetalert2';
import Vue from 'vue'
export default {
  data() {
    return {
      loading: false,
      isEditing: false,
      searchQuery: '',
      approveuserslist: [], // Data to store user list from API
      selectedProcess: null,
      selectedCondition: null,
      lastmodifieddate:null,
      lastmodifiedby:null,
      searchQueryLevel1: '',
      searchQueryLevel2: '',
      searchQueryLevel3: '',
      bsplPercentage: null,  // Data for BSPL input
      darpPercentage: null,  // Data for DARP input
      bsplInvalid: false,
      darpInvalid: false,
      levels: {
        level1: false,
        level2: false,
        level3: false,
      },
      mandatoryUsers: {
        level1: [],
        level2: [],
        level3: [],
      },
      existingConfigurations: [], // Array of existing configurations
      processes: [], // Array of processes
      conditions: [], // Array of conditions
      availableUsers: [], // Array of available users
      errors: {
        process: null,
        condition: null,
        level1Users: null,
        level2Users: null,
        level3Users: null,
        duplicateUsers:null,
      }
    };
  },
  mounted() {   
    this.fetchConfigurations();
    this.getApproveUsers();
    this.getApprovalProcessModule();
    
  },
  computed: {
    filteredConfigurations() {
      if (!this.searchQuery) return this.existingConfigurations;
      const queryWords = this.searchQuery.toLowerCase().trim().split(/\s+/);
        return this.existingConfigurations.filter(item => {
      // Format the module URL and convert it to lowercase
      const formattedModuleUrl = this.formatModuleUrl(item.moduleurl).toLowerCase();
      const condition = item.approvalcondition.toLowerCase(); // Convert condition to lowercase

      // Check if all query words are included in either the formatted module URL or condition
      return queryWords.every(word => 
        formattedModuleUrl.includes(word) || condition.includes(word) || 
        item.no_of_level.toString().includes(word) // Include this if you want to filter by No Of Level as well
      );
    });

      
    },
    isLevel2Enabled() {
      return this.levels.level1 && this.mandatoryUsers.level1.length > 0;
    },
    isLevel3Enabled() {
      return this.levels.level1 && this.mandatoryUsers.level1.length > 0 && this.levels.level2 && this.mandatoryUsers.level2.length > 0;
    }
  },
  methods: {
    validatePercentages() {
  
        const bsplPercentage = this.bsplPercentage != null ? this.bsplPercentage : 0;
        const darpPercentage = this.darpPercentage != null ? this.darpPercentage : 0;
        const totalPercentage = Number(bsplPercentage) + Number(darpPercentage);


      // Validate BSPL percentage
      this.bsplInvalid = !this.bsplPercentage || this.bsplPercentage < 0 || this.bsplPercentage > 100;
      
      // Validate DARP percentage
      this.darpInvalid = !this.darpPercentage || this.darpPercentage < 0 || this.darpPercentage > 100;
      
          console.log('validatePercentages bsplInvalid',this.bsplInvalid);
          console.log('validatePercentages darpInvalid',this.darpInvalid);

      // If the total is greater than 100, mark both inputs as invalid
      if (totalPercentage > 100) {
      this.errors.bsplPercentage=' BSPL (%) and DARP(%) Total percentage cannot exceed 100';
        this.bsplInvalid = true;
        this.darpInvalid = true;
      }else{
       this.errors.bsplPercentage=null;
       this.errors.bsplPercentage=null;
      }
    },
     capitalizeFirstLetter(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    systemUserConfig() {
      this.getSystemUserByModule(); // Fetch data when opening modal
      this.$refs.approverConfigModal.show();
    },

    // Function to close modal
    closeConfigModal() {
      this.$refs.approverConfigModal.hide();
    },

    // Fetch data from API
    getSystemUserByModule() {
      this.loading = true;
      const obj = {
        module: "vendor_onboarding",
        approverUser: "Yes",
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getSystemUserByModule`, obj)
        .then((result) => {
          if (result.body.returnstatus === "Successful") {
            this.approveuserslist = result.body.returnvalue;
          } else {
            this.approveuserslist = [];
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        })
        .finally(() => {
          this.loading = false; // Stop loader when request completes
        });
    },

    // Function to get approval level based on module
    getApprovalLevel2(user, module) {
      // Check if user and its approval_action exist
      if (user && user.approval_action) {
        const approvalAction = user.approval_action.find(action => action.module === module);
        return approvalAction ? approvalAction.level : '-';
      }
      return '-'; // Return 'N/A' if approval_action or user is null
    },
    getApprovalLevel(user, module) {
      if (user && user.approval_action) {
        // Flatten any nested arrays in approval_action
        const flatApprovalAction = user.approval_action.flat();
        // Find the action for the specified module
        const approvalAction = flatApprovalAction.find(action => action.module === module);
        return approvalAction ? approvalAction.level : '-';
      }
      return '-';
    },
    selectedUsers(level) {
      return this.mandatoryUsers[level];
    },
    nonSelectedUsers(level) {
      return this.filteredUsers(level).filter(
        user => !this.mandatoryUsers[level].includes(user)
      );
    },
    filteredUsers(level) {
      let searchQuery = '';
      
      // Assign the search query based on the level
      if (level === 'level1') {
        searchQuery = this.searchQueryLevel1.toLowerCase();
      } else if (level === 'level2') {
        searchQuery = this.searchQueryLevel2.toLowerCase();
      } else if (level === 'level3') {
        searchQuery = this.searchQueryLevel3.toLowerCase();
      }

      // Filter the available users by matching the email with the search query
      return this.availableUsers.filter(user => {
        //return user.sysemailid.toLowerCase().includes(searchQuery);
            return user.sysemailid.toLowerCase().startsWith(searchQuery.toLowerCase());

      });
    },
    
    fetchConfigurations() {
          // Simulate fetching data from an API
          this.loading = true; // Start loader
          const obj = {
            status: "active",
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getFetchConfigurations`, obj).then((result) => {
              if (result.body.returnstatus === "Successful") {
              this.existingConfigurations=result.body.returnvalue;
              }else{
              this.existingConfigurations=[];
              }
          }).catch((ex) => {
              console.log("error-----", ex);            
          }).finally(() => {
              this.loading = false; // Stop loader when request completes
          });
    },
    formatModuleUrl(url) {
    // Replace underscores with spaces and capitalize each word
    return url
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space between camel case words
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
  },
                  //userType:[1,2,3,4]

    getApproveUsers() {
          this.loading = true; // Start loader
          const obj = {
              userType:[1,2,3,4]
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getApproveUsers`, obj).then((result) => {
              if (result.body.returnstatus === "Successful") {
              this.availableUsers=result.body.returnvalue;
              }else{
              this.availableUsers=[];
              }
          }).catch((ex) => {
              console.log("error-----", ex);            
          }).finally(() => {
              this.loading = false; // Stop loader when request completes
          });
    },
    getApprovalProcessModule() {
        this.loading = true; // Start loader
        const obj = {
            "status": "active"
        };
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getApprovalProcessModule`, obj)
            .then((result) => {
                if (result.body.returnstatus === "Successful") {
                    this.processes = result.body.returnvalue;
                    // If you want to pre-select the first process and get its conditions
                    if (this.processes.length > 0) {
                        this.selectedProcess = this.processes[0].moduleurl; // Default selection
                        this.updateConditions(this.processes[0].modulecondition);
                    }
                } else {
                    this.processes = [];
                }
            })
            .catch((ex) => {
                console.log("error-----", ex);
            })
            .finally(() => {
                this.loading = false; // Stop loader when request completes
            });
    },
    updateConditions(modulecondition) {
        // Parse the conditions if they exist
        if (modulecondition) {
            try {
                const parsedConditions = JSON.parse(modulecondition);
                this.conditions = parsedConditions.map((condition, index) => ({
                    id: index + 1, // Assign an ID based on the index
                    name: condition
                }));
                
                 if (this.selectedProcess === 'trip_level_invoice_generator') {
                  // Set default selectedCondition if it's null
                  if (!this.selectedCondition && this.conditions.length > 0) {
                    this.selectedCondition = this.conditions[0].name;
                  }
                }
            } catch (error) {
                console.error("Error parsing conditions:", error);
                this.conditions = []; // Reset if parsing fails
            }
        } else {
            this.conditions = []; // Reset if no conditions
        }
    },
    openNewConfig() {
      this.resetConfig();
      this.$refs['viewPlanDetails-modal'].show();
    },
    editProcess(config) {
      console.log('editProcess-----',config);
      this.isEditing = true;
      this.selectedProcess = config.moduleurl;
      this.selectedCondition = config.approvalcondition ? config.approvalcondition : null;
      this.bsplPercentage = config.bspl_percentage ? config.bspl_percentage : null;
      this.darpPercentage = config.darp_percentage ? config.darp_percentage : null;
      this.levels = config.levels;
      this.mandatoryUsers = config.mandatoryUsers; // Ensure this contains selected users
      if (config.lastmodifieddate) {
          this.lastmodifieddate = new Date(config.lastmodifieddate).toLocaleDateString('en-US', { 
            year: 'numeric', month: 'long', day: 'numeric', 
            hour: '2-digit', minute: '2-digit'
          });
        } else {
          this.lastmodifieddate = null; // Set to null if no date is provided
        }
      this.lastmodifiedby=config.lastmodifiedby;
      this.$refs['viewPlanDetails-modal'].show();
    },
   

    validateForm() {
      // Clear previous errors
      this.errors = {
        process: null,
        condition: null,
        level1Users: null,
        level2Users: null,
        level3Users: null,
        duplicateUsers:null,
        bsplPercentage: null,
        darpPercentage: null,
      };

      // Ensure at least one level is active
      if (!this.levels.level1 && !this.levels.level2 && !this.levels.level3) {
        this.levels.level1 = true; // Default to Level 1 active
      }

      // Validate fields
      if (!this.selectedProcess) {
        this.errors.process = 'Approval process is required.';
      }
      //if (!this.selectedCondition) {
      //  this.errors.condition = 'Condition is required.';
      //}
      console.log('this.selectedCondition',this.selectedCondition);
      if (this.selectedCondition &&  this.selectedCondition=='percentage') {
        // Validate that both bsplPercentage and darpPercentage are required
        if (this.bsplPercentage == null || this.darpPercentage == null) {
          if (this.bsplPercentage == null) {
            this.errors.bsplPercentage = 'BSPL (%) is required.';
          }
          if (this.darpPercentage == null) {
            this.errors.darpPercentage = 'DARP (%) is required.';
          }
        }
        const bsplPercentage = this.bsplPercentage != null ? this.bsplPercentage : 0;
        const darpPercentage = this.darpPercentage != null ? this.darpPercentage : 0;
        const totalPercentage = Number(bsplPercentage) + Number(darpPercentage);
        console.log('totalPercentagetotalPercentage',totalPercentage);
        if(totalPercentage!=100){
          if (totalPercentage > 100) {
            this.errors.bsplPercentage=' BSPL (%) and DARP(%) Total percentage cannot exceed 100';
          }else{
            this.errors.bsplPercentage=' BSPL (%) and DARP(%) Total percentage cannot less than 100';
          }
        }
      }else{
       this.bsplPercentage=null;
       this.darpPercentage=null;
      }

      if (this.levels.level1 && (!this.mandatoryUsers.level1 || !this.mandatoryUsers.level1.length)) {
        this.errors.level1Users = 'At least one Level 1 approver is required.';
      }
      
      const allMandatoryUsers = [
        ...this.mandatoryUsers.level1,
        ...this.mandatoryUsers.level2,
        ...this.mandatoryUsers.level3,
      ];
      console.log('allMandatoryUsers>>>',allMandatoryUsers);
      const uniqueUsers = new Set(allMandatoryUsers.map(user => user.sysusermasterid));
      if (uniqueUsers.size !== allMandatoryUsers.length) {
        this.errors.duplicateUsers = 'A same user cannot be selected in multiple levels.';
        
         this.$fire({
                text: 'A same user cannot be selected in multiple levels.',
                type: "error",
                timer: 30000,
              });
      }

      // Level 2 validation depends on Level 1
      if (this.levels.level2) {
        if (!this.mandatoryUsers.level2 || !this.mandatoryUsers.level2.length) {
          this.errors.level2Users = 'At least one Level 2 approver is required.';
        }
        // Check if at least one user from Level 1 is selected before allowing Level 2
        if (this.mandatoryUsers.level1.length === 0) {
          this.errors.level2Users = 'Select at least one Level 1 approver before Level 2.';
        }
      }

      if (this.levels.level3 && (!this.mandatoryUsers.level3 || !this.mandatoryUsers.level3.length)) {
        this.errors.level3Users = 'At least one Level 3 approver is required.';
      }

      // If there are errors, return early
      if (Object.values(this.errors).some(error => error)) {
        return;
      }

      // Proceed with saving if no errors
      this.saveConfig();
    },

    saveConfig() {
      // Prepare the configuration object
      this.isLoading=true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);  
      const config = {
        process: this.selectedProcess,
        isEditing:this.isEditing,
        condition: this.selectedCondition,
        bsplPercentage: this.bsplPercentage,
        darpPercentage: this.darpPercentage,
        levels: this.levels,
        mandatoryUsers: this.mandatoryUsers,
        uploadedby:`${userInfo.sysemailid}`
      };
      console.log('Configuration saved:', config);
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/addNewApproverConfiguration`,
            config
          )
          .then((result) => {
            console.log("Test>>>>>>>>>>>>>>>>>>>>", result.body);
            if (result.body.returnstatus === "Successful") {
                if(this.isEditing){
                  this.$fire({
                      text: "Update Successfully",
                      type: "success",
                      timer: 30000,
                    });
                }else{
                  this.$fire({
                    text: "Added Successfully",
                    type: "success",
                    timer: 30000,
                  });
                }
                this.$refs['viewPlanDetails-modal'].hide();
                this.resetConfig(); // Reset after saving
                this.fetchConfigurations();
            } else {
              this.$fire({
                text: result.body.returnmsg,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
             Swal.fire({
              title: 'Error',
              text: 'An error occurred while addNewApproverConfiguration. Please try again.',
              icon: 'error',
              confirmButtonText: 'Close',
            });
          });

     
    },
    clearError(field) {
    
      // Clear the specific error message for the field
      this.errors[field] = null;
    },
    resetConfig() {
      this.searchQueryLevel1= '';
      this.searchQueryLevel2= '';
      this.searchQueryLevel3= '';
      this.selectedProcess = null;
      this.selectedCondition = null;
      this.darpPercentage=null,
      this.bsplPercentage=null,
      this.levels = { level1: false, level2: false, level3: false };
      this.mandatoryUsers = { level1: [], level2: [], level3: [] };
      this.errors = {}; // Reset errors
      this.isEditing = false;
      this.fetchConfigurations();

    },
    handleLevel1Change() {
      // If Level 1 is deselected, clear Level 2 and 3 options and users
       console.log('handleLevel1Change',this.levels.level1);
      if (this.levels.level1) {     
        this.levels.level2 = false;
        this.levels.level3 = false;
        this.mandatoryUsers.level1 = [];
        this.mandatoryUsers.level2 = [];
        this.mandatoryUsers.level3 = [];
        this.clearError('level1Users');  
        this.clearError('level2Users');
        this.clearError('level3Users');
      }
        
    },
    handleLevel2Change() {
      // If Level 2 is selected, we want to disable Level 3
      if (this.levels.level2) {
        this.mandatoryUsers.level2 = [];
        this.levels.level3 = false; // Uncheck Level 3 if it's currently checked
        this.mandatoryUsers.level3 = [];
      }
      this.clearError('level2Users');
    },
     handleLevel3Change() {
      if (!this.levels.level3) {        
        this.mandatoryUsers.level3 = [];
      }
      this.clearError('level3Users');
    },
    updateMandatoryUsers(level, user) {
        // Example logic to update mandatory users, add/remove as necessary
        const index = this.mandatoryUsers[level].indexOf(user);
        if (index === -1) {
          this.mandatoryUsers[level].push(user);
        } else {
          this.mandatoryUsers[level].splice(index, 1);
        }

        const level1Selected = this.mandatoryUsers.level1.length > 0;
        const level2Selected = this.mandatoryUsers.level2.length > 0;
        const level3Selected = this.mandatoryUsers.level3.length > 0;

        // Check for Level 1
        if (level === 'level1') {
            if (!this.mandatoryUsers.level1.includes(user)) {
            console.log('level1Selected-----',this.mandatoryUsers.level1.length);
              // If user is being removed, check if Level 2 or Level 3 is selected
              if ((this.mandatoryUsers.level1.length==0 && (level2Selected || level3Selected))) {
                          console.log('level1Selected-----',this.mandatoryUsers.level1.length);

                this.$bvToast.toast('Cannot remove Level 1 Approver while Level 2 or Level 2 & Level 3 Approvers are selected.', {
                  title: 'Warning',
                  variant: 'warning',
                  autoHideDelay: 3000,
                });
                return; // Prevent removal
              }
            }
        }
        // Check for Level 2
        if (level === 'level2') {
          if (this.mandatoryUsers.level2.includes(user)) {
            // If user is being selected, Level 1 must be selected
            if (!level1Selected) {
              this.$bvToast.toast('At least one Level 1 Approver must be selected before adding Level 2 Approvers.', {
                title: 'Warning',
                variant: 'warning',
                autoHideDelay: 3000,
              });
              this.mandatoryUsers.level2 = this.mandatoryUsers.level2.filter(u => u !== user); // Remove user selection
            }
          } else {
            // If user is being unselected, Level 3 must be unchecked if Level 2 is being unchecked
            if (!this.mandatoryUsers.level2.length && this.mandatoryUsers.level3.length!=0) {
            console.log('level3.length',this.mandatoryUsers.level3.length)
              this.levels.level3 = false;
              this.mandatoryUsers.level3 = [];
              this.$bvToast.toast('Level 3 Approver selection has been cleared because Level 2 is no longer selected.', {
                title: 'Info',
                variant: 'info',
                autoHideDelay: 3000,
              });
            }
          }
        }
        // Check for Level 3
        if (level === 'level3') {
          if (this.mandatoryUsers.level3.includes(user)) {
            // If user is being selected, Level 2 must be selected
            if (!level2Selected) {
              this.$bvToast.toast('At least one Level 2 Approver must be selected before adding Level 3 Approvers.', {
                title: 'Warning',
                variant: 'warning',
                autoHideDelay: 3000,
              });
              this.mandatoryUsers.level3 = this.mandatoryUsers.level3.filter(u => u !== user); // Remove user selection
            }
          }
        }
        console.log('this.mandatoryUsers',this.mandatoryUsers);
    },
  
  
  },
  watch: {
       
        selectedProcess(newValue) {
        console.log('selectedProcessselectedProcessselectedProcess',newValue);
            const selectedProcess = this.processes.find(process => process.moduleurl === newValue);
           
                    console.log('this.selectedCondition',this.selectedCondition);

                    if((this.selectedCondition!='percentage' || newValue!='trip_level_invoice_generator')){
                    console.log('this.selectedConditionssssssssssssssssssss');
                    this.bsplPercentage = null;
                    this.darpPercentage = null;
                    this.selectedCondition=null;
                    }
                    

            if (selectedProcess) {
                this.updateConditions(selectedProcess.modulecondition);
            } else {
                this.conditions = []; // Reset if no process matches
            }
        }
  } 
};
</script>
<style scoped>
.radio-group-custom {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.5rem;
  margin-left:20px;
}

/* Styles for each radio button */
.radio-custom .custom-control-label {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 5px;
  padding: 5px 10px;
  color: #333;
  font-weight: 500;
  border: 1px solid #ddd;
  transition: background-color 0.2s ease;
}

.radio-custom .custom-control-label:hover {
  background-color: #e0e0e0;
}

.radio-custom .custom-control-input:checked ~ .custom-control-label {
  background-color: #20A8D8;
  color: #fff;
  border-color: #20A8D8;
}
.underline {
  text-decoration: underline;
}
.approver-config-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 8px;
}
.loader {
  text-align: center;
  font-weight: bold;
}
.btn-add {
  float: right;
}
.no-records {
  text-align: center;
  color: red;
  font-weight: bold;
}

.form-group {
  margin-bottom: 20px;
}

.form-control {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.approval-levels label {
  display: inline-block;
  margin-right: 10px;
}

.btn {
  padding: 10px 20px;
  margin-right: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.approver-form {
  border: 1px solid #dcdcdc; /* Light grey border */
  padding: 20px;
  border-radius: 5px; /* Rounded corners */
  background-color: #f9f9f9; /* Light background */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); /* Soft shadow */
}



.footer-buttons {
  margin-top: 20px; /* Space above the buttons */
  padding: 15px 0; /* Padding around the buttons */
  border-top: 1px solid #dcdcdc; /* Light grey border at the top */
  background-color: #f9f9f9; /* Matching background color */
}

.btn-save {
  background-color: #4CAF50; /* Green background */
  color: white;
  border: none;
  padding: 10px 20px; /* More padding for better touch targets */
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px; /* Space between buttons */
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}

.btn-save:hover {
  background-color: #45a049; /* Darker green on hover */
}

.btn-reset {
  background-color: #f44336; /* Red background */
  color: white;
  border: none;
  padding: 10px 20px; /* More padding for better touch targets */
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}

.btn-reset:hover {
  background-color: #e53935; /* Darker red on hover */
}

.existing-process-list {
  list-style: none;
  padding: 0;
}

.existing-process-list li {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.remove-btn, .edit-btn {
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
}

.remove-btn:hover, .edit-btn:hover {
  text-decoration: underline;
}

.search-bar {
  margin: 20px 0;
}

.search-bar input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
}
.b-table {
  margin-bottom: 20px;
}

.edit-btn {
  margin-left: 10px;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;

}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  font-weight: bold;
  text-align: center; /* Center align text in table headers */
}


.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}
.custom-checkbox .form-check-input {
  width: 20px;   /* Set width */
  height: 20px;  /* Set height */
  border-radius: 0; /* Remove border radius for square shape */
  border: 2px solid #007bff; /* Customize border color */
}

.custom-checkbox .form-check-input:checked {
  background-color: #007bff; /* Background color when checked */
  border-color: #007bff; /* Border color when checked */
}

.custom-checkbox .form-check-input:focus {
  box-shadow: none; /* Remove focus shadow */
}
.user-list-scroll {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  margin-top: 10px;
}
.badge-info {
  margin-left: 10px;
}
h5{
    font-size: 13px;
    margin-top: 11px;
}
.custom-control{
padding-left: 0rem

}
/* Tooltip content styling */
.tooltip-content2 {
  background-color: #444; /* Darker background for better contrast */
  color: #fff; /* White text for readability */
  border-radius: 5px; /* Slightly rounded corners */
  padding: 12px; /* Padding around the content */
  font-size: 14px; /* Font size */
  max-width: 300px; /* Maximum width of the tooltip */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* Subtle shadow for depth */
  word-wrap: break-word; /* Allows long words to break and prevent overflow */
}

/* Inline list styling */
.inline-list {
  list-style: none; /* Remove bullet points */
  padding: 0; /* Remove default padding */
  margin: 0; /* Remove default margin */
  display: flex; /* Use flexbox for inline display */
  flex-direction: row; /* Items in a row */
  flex-wrap: wrap; /* Allow items to wrap to the next line if needed */
}

/* Individual list item styling */
.inline-list li {
  flex: 0 0 auto; /* Allow items to take their intrinsic width */
  min-width: 200px; /* Minimum width for each list item */
  max-width: 250px; /* Maximum width for each list item */
  margin-right: 15px; /* Space between items */
  margin-bottom: 5px; /* Space between rows of items */
  font-size: 12px; /* Font size for list items */
  color: #add8e6; /* Light blue color for email addresses */
  white-space: nowrap; /* Prevent wrapping of text */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Add ellipsis for overflow text */
}

/* Optional: Hover effect for list items */
.inline-list li:hover {
  text-decoration: underline; /* Underline on hover for better interaction */
  color: #ffffff; /* Change color on hover */
}


</style>
